import {useMemo} from 'react'
import {ISidebarInputProps} from '@/Types/Input'
import {toCamelCase} from '@/Utils/Strings'

export function useSidebarInput(
    {
        id: idProp,
        title,
        error,
    }: ISidebarInputProps) {
    const id: string = useMemo(() => (idProp ?? toCamelCase(String(title ?? '')) ?? ''), [idProp, title])

    return {
        id,
        hasError: !!error,
    }
}
